
import React, { useState } from 'react';

import Header from '../components/landing/Header';
import HeroSection from '../components/landing/HeroSection';
import RemoteTeamSection from '../components/landing/RemoteTeamSection';
import InnovationSection from '../components/landing/InnovationSection';
import PreviousWorksSection from '../components/landing/PreviousWorksSection';
import OurServicesSection from '../components/landing/OurServicesSection';
import CertificationSection from '../components/landing/CertificationSection';
import ReviewSection from '../components/landing/ReviewSection';
import SupportSection from '../components/landing/SupportSection';
import GetStartedSection from '../components/landing/GetStartedSection';
import Footer from '../components/landing/Footer';
import PromotionalPopup from '../components/common/PromotionalPopup';

const LandingPage = () => {
  return (
    <div>
      <Header />
      <HeroSection />
      <RemoteTeamSection />
      <InnovationSection />
      <PreviousWorksSection />
      
      <OurServicesSection />
      <CertificationSection />
      
      <ReviewSection />
      <SupportSection />
      <GetStartedSection />
      <Footer />
    </div>
  );
};

export default LandingPage;

